import React, { Component, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import ComponentName from '../../constant/ComponentName';
import { Tooltip } from 'primereact/tooltip';

class SidebarMenuItem extends Component<Props> {
  public render() {
    const { item, goPage, pathName, collapsed } = this.props;
    return (
      <Link
        key={item.name}
        id={item.name}
        to={item.path}
        onClick={(e) => {
          if (e.metaKey || e.ctrlKey) return;
          goPage(item);
        }}
        className={`flex px-2 py-2.5 text-center group items-center hover:bg-secondary text-f-black-2 hover:text-primary hover:border-l-primary border-l-[6px] shrink-0 fill-f-black-3 hover:fill-primary rounded mb-0.5 h-[40px] lg:self-start w-full ${pathName == item.path ? 'bg-secondary border-l-[6px] text-primary border-l-primary fill-primary' : 'border-l-transparent '}`}
      >
        <div className={'ml-1'}>{item.icon}</div>
        <span className={`font-medium tracking-widest text-xs ml-2 ${collapsed && window.screen.width > 1024 && 'hidden'} `}>{item.name}</span>
        {collapsed && (
          <Tooltip target={`#${item.name}`} position='right'>
            {item.name}
          </Tooltip>
        )}
      </Link>
    );
  }
}

export type SidebarMenuItemProps = {
  name: string;
  path: string;
  field: string;
  icon: ReactNode;
  children: SidebarMenuItemProps[];
  component: ComponentName;
  visible?: boolean;
};

interface Props {
  item: SidebarMenuItemProps;
  goPage: (m: SidebarMenuItemProps) => void;
  pathName: string;
  collapsed: boolean;
}

export default SidebarMenuItem;
